import { useState } from 'react'
import './Header.css'

export function Header() {
  const [searchQuery, setSearchQuery] = useState('')

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    console.log('Searching for:', searchQuery)
  }

  return (
    <header className="header">
      <div className="logo">
        <h1>Soundmaster</h1>
        <p className="tagline">Professional Sound Services - Tzaneen & Limpopo Area</p>
      </div>
      <nav className="nav">
        <ul>
          <li><a href="#party">Party Sound</a></li>
          <li><a href="#karaoke">Karaoke</a></li>
          <li><a href="#wedding">Wedding Sound</a></li>
          <li><a href="#live">Live Streaming</a></li>
        </ul>
      </nav>
      <div className="contact-info">
        <a href="tel:0815436748" className="phone">📞 081 543 6748</a>
        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="search"
            placeholder="Search songs..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            aria-label="Search songs"
          />
          <button type="submit" aria-label="Search">🔍</button>
        </form>
      </div>
    </header>
  )
} 